import React from 'react';
import LessonAssignmentView from './LessonAssignment';
import { LessonAssignmentFooter } from './components/LessonAssignmentFooter';
import { LessonAssignmentProvider } from 'state/providers/LessonAssignmentProvider/LessonAssignmentProvider';

const LessonAssignment: React.FC = () => {
  return (
    <LessonAssignmentProvider>
      <LessonAssignmentView />
      <LessonAssignmentFooter />
    </LessonAssignmentProvider>
  );
};

export default LessonAssignment;
